import React, { useContext, useState } from "react";
import classNames from "classnames";
import { useApiGet } from "../utils/useApi";
import { useHistory } from "react-router-dom";
import AzureMediaPlayer from "../shared/AzureMediaPlayer";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import styles from "./SessionVideos.module.css";
import { ResponsiveContext } from "../shared/layout/ResponsiveContext";
import SyncedVideos from "./SyncedVideos";

export default props => {
  const { session } = props;
  const history = useHistory();
  const { isMobile, isTablet } = useContext(ResponsiveContext);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showSynced, setShowSynced] = useState(false);
  const [videos] = useApiGet(
    `Result/Videos/${session.resultId}`,
    null,
    history
  );

  const getSource = video => {
    const urls = video.urls || [];
    const hls = urls.find(url => url.includes(".m3u8"));
    if (hls)
      return {
        src: hls,
        type: "application/vnd.apple.mpegurl",
        sasToken: video.sasToken
      };
    const mp4 = urls.find(url => url.includes(".mp4"));
    if (mp4) return { src: mp4, type: "video/mp4" };
    return null;
  };

  const anyUrls =
    videos.data &&
    videos.data.map(video => video.urls).some(urls => urls && urls[0]);

  const renderVideo = (video, index) => {
    const videoId = selectedVideo && selectedVideo.id;
    const selectedSource = selectedVideo ? getSource(selectedVideo) : null;
    const videoSource = getSource(video);
    const source = selectedSource || videoSource;
    const autoplay = !!selectedVideo;
    const key = `${video.name}_${session.resultId}_${autoplay}`;

    return (
      <div key={key}>
        {source && (
          <>
            <p
              className={styles.video_link}
              onClick={() => setSelectedVideo(video)}
            >
              <PlayCircleOutlineIcon className={styles.video_link_icon} />
              {`${video.type} - ${video.name}`}
            </p>
            {(videoId === video.id || (!videoId && index === 0)) && (
              <div
                className={classNames(styles.video_player, {
                  [styles.video_player_mobile]: isTablet
                })}
              >
                <AzureMediaPlayer options={{ autoplay }} src={[source]} />
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const standardVideos = (videos.data || []).filter(
    v => v.type !== "Interview Video"
  );
  const debriefVideos = (videos.data || [])
    .filter(v => v.type === "Interview Video")
    .sort((a, b) => new Date(b.Time) - new Date(a.Time));

  if (showSynced && standardVideos.length > 0) {
    return (
      <SyncedVideos
        session={session}
        videos={standardVideos}
        onBack={() => setShowSynced(false)}
      />
    );
  }

  return (
    <>
      {anyUrls && (
        <div
          className={classNames(styles.session_videos, "hide_print", {
            [styles.session_videos_mobile]: isMobile
          })}
        >
          <Typography variant="h6">
            {`${session.name || session.uniqueId} - ${session.platformName} - ${
              session.testName
            }`}
          </Typography>
          <Typography variant="subtitle1">
            {session.timeCollected
              ? require("moment")
                  .utc(session.timeCollected)
                  .local()
                  .format("MMM Do YYYY, h:mm a")
              : session.dateString}
          </Typography>

          {standardVideos.map((video, index) => renderVideo(video, index))}

          {debriefVideos.length > 0 && (
            <>
              <Divider className={styles.debrief_divider} />
              <Typography variant="subtitle2" className={styles.debrief_header}>
                Debrief Videos
              </Typography>
              {debriefVideos.map((video, index) => renderVideo(video, index))}
            </>
          )}

          {standardVideos.length > 0 && (
            <>
              <Divider className={styles.debrief_divider} />
              <p
                className={styles.video_link}
                onClick={() => setShowSynced(true)}
              >
                <PlayCircleOutlineIcon className={styles.video_link_icon} />
                View all cameras synchronized (Preview)
              </p>
            </>
          )}
        </div>
      )}
    </>
  );
};
